__turbopack_context__.v({
  "benefitsContent": "page-module__SbWuaW__benefitsContent",
  "benefitsTitle": "page-module__SbWuaW__benefitsTitle",
  "card": "page-module__SbWuaW__card",
  "cardBadges": "page-module__SbWuaW__cardBadges",
  "cardBtn": "page-module__SbWuaW__cardBtn",
  "cardIcons": "page-module__SbWuaW__cardIcons",
  "cardImage": "page-module__SbWuaW__cardImage",
  "cardImageSquare": "page-module__SbWuaW__cardImageSquare",
  "cardImageTall": "page-module__SbWuaW__cardImageTall",
  "cardImageWide": "page-module__SbWuaW__cardImageWide",
  "cardMediaFrame": "page-module__SbWuaW__cardMediaFrame",
  "cardMediaLink": "page-module__SbWuaW__cardMediaLink",
  "cardText": "page-module__SbWuaW__cardText",
  "cardTitle": "page-module__SbWuaW__cardTitle",
  "cardTitleLink": "page-module__SbWuaW__cardTitleLink",
  "contentAnchor": "page-module__SbWuaW__contentAnchor",
  "descHtml": "page-module__SbWuaW__descHtml",
  "dynamicIconMappingWrapper": "page-module__SbWuaW__dynamicIconMappingWrapper",
  "error": "page-module__SbWuaW__error",
  "header": "page-module__SbWuaW__header",
  "headerBenefits": "page-module__SbWuaW__headerBenefits",
  "headerDesc": "page-module__SbWuaW__headerDesc",
  "headerImage": "page-module__SbWuaW__headerImage",
  "kitCard": "page-module__SbWuaW__kitCard",
  "kitCardBody": "page-module__SbWuaW__kitCardBody",
  "kitCardHeader": "page-module__SbWuaW__kitCardHeader",
  "kitCardelemental": "page-module__SbWuaW__kitCardelemental",
  "kitCardessential": "page-module__SbWuaW__kitCardessential",
  "kitCardultra": "page-module__SbWuaW__kitCardultra",
  "kitDescription": "page-module__SbWuaW__kitDescription",
  "kitDetailsButton": "page-module__SbWuaW__kitDetailsButton",
  "kitDivider": "page-module__SbWuaW__kitDivider",
  "kitFeature": "page-module__SbWuaW__kitFeature",
  "kitFeatureGrid": "page-module__SbWuaW__kitFeatureGrid",
  "kitFeatureIncluded": "page-module__SbWuaW__kitFeatureIncluded",
  "kitFeatureMuted": "page-module__SbWuaW__kitFeatureMuted",
  "kitGrid": "page-module__SbWuaW__kitGrid",
  "kitHeading": "page-module__SbWuaW__kitHeading",
  "kitsSection": "page-module__SbWuaW__kitsSection",
  "productsGrid": "page-module__SbWuaW__productsGrid",
  "sectionEyebrow": "page-module__SbWuaW__sectionEyebrow",
  "sectionHeader": "page-module__SbWuaW__sectionHeader",
  "share": "page-module__SbWuaW__share",
  "title": "page-module__SbWuaW__title",
  "wrapper": "page-module__SbWuaW__wrapper",
});
